import React from 'react';
import { Helmet } from 'react-helmet';
import Layout from '../../components/layout';
import Hero from '../../components/hero';
import SecondaryContent from '../../components/secondaryContent';
import Testimonials from '../../components/testimonials';
import FaqAccordion from '../../components/faqAccordion';

export default function NewCustomerIntake({ location }) {
  const heroData = {
    heading: 'New Customer Intake',
  };

  const contentData = [
    {
      id: 1,
      heading: 'Why Ring Savvy is the best live answering service for you',
      content:
        'Our 24/7 virtual receptionist team is committed to not just answering your business’ phones, but helping your company convert its new leads into paying customers. Providing a live answer to customers during their time of need means everything these days, and utilizing Ring Savvy will guarantee you’re always able to offer a high quality customer service experience to new prospects.',
    },
  ];

  const learnMoreData = [
    {
      heading: 'How our service works',
      content:
        'You’ll have full control of how our receptionist team manages your phone lines and engages with your callers.',
      ctaText: 'Learn how our service works',
      ctaLink: '/how-it-works/',
    },
    {
      heading: 'Competitive Pricing',
      content:
        'Use our price estimator tool to find out how much you’ll be spending on our service each month.',
      ctaText: 'View our pricing structure',
      ctaLink: '/pricing/',
    },
    {
      heading: 'Try the service free for 14 days',
      content:
        'Experience all Ring Savvy has to offer, without paying a cent. All business owners are encouraged to sign up for a free trial with our company.',
      ctaText: 'Start your free trial',
      ctaLink: '/sign-up/',
    },
  ];

  return (
    <Layout location={location}>
      <Helmet>
        <title>
          New Customer Intake | Capture Leads and Convert Them to Customers!
        </title>
        <meta
          name='description'
          content='New Customer Intake | Capture Leads and Convert Them to Customers! Ring Savvy | Increase Your Bottom Line, Try Us Free For 7 Days.'
        />
      </Helmet>
      <Hero heading={heroData.heading} />
      <SecondaryContent hasSidebar learnMoreData={learnMoreData}>
        <p>
          For those unfamiliar with the term, new customer intake is the
          procedure in which a receptionist gathers information from a
          first-time caller to a business. The receptionist executes the process
          by asking the caller a series of predetermined questions.
        </p>
        <p>
          Ring Savvy is not just the best phone answering service on the market
          today, but the best answering service for capturing new leads. This is
          largely because of the rigorous New Customer Intake training we put
          our virtual receptionist team members through. By the time one of our
          receptionists performs a customer intake on behalf of a business like
          yours, they will have already completed the procedure hundreds of
          times before.
        </p>
        <p>
          If your business is devoting time and money to marketing and
          advertising campaigns, you need to make sure your efforts aren’t being
          wasted by sloppy lead capturing. The best way to ensure that the new
          leads generated by your advertising actually turn into paying
          customers is by investing in a high quality New Customer Intake
          service like Ring Savvy’s. For just a small additional cost, our
          highly trained receptionist team, can start capturing new leads on
          behalf of your company.
        </p>
        <h2>How Do We Perform New Customer Intake?</h2>
        <p>
          When a member of our virtual receptionist team answers one of your
          incoming calls, they will begin by finding out if the caller is
          reaching out to your business for the first time. If it is their first
          time calling you, and you are unavailable to speak with the caller
          yourself, our receptionist will begin taking the caller through the
          New Customer Intake process.
        </p>
        <h4>
          Our intake process begins with our receptionist gathering your
          caller’s personal information. This will include:
        </h4>
        <ul>
          <li>Their full name</li>
          <li>The best phone number to reach them at</li>
          <li>Their home address</li>
          <li>Their email address</li>
        </ul>
        <p>
          After all personal information is gathered, our receptionists will
          move on to collecting information about the caller’s reason for
          contacting your business. They will accomplish this by asking specific
          questions, which you’ll be able to customize when setting up your
          account with Ring Savvy.
        </p>
        <h4>
          Here are a few examples of questions we can ask on behalf of different
          businesses:
        </h4>
        <p>
          <b>For plumbing companies we can ask:</b>{' '}
          <i>
            “Are you reaching out today for help with an installation or
            repair?”
          </i>
        </p>
        <p>
          <b>For pet grooming companies we can ask:</b>{' '}
          <i>“What breed of dog are you looking to make an appointment for?”</i>
        </p>
        <p>
          <b>For real estate companies we can ask:</b>{' '}
          <i>“Are you looking to buy or sell property?”</i>
        </p>
      </SecondaryContent>
      <Testimonials />
      <FaqAccordion contentData={contentData.find((data) => data.id === 1)} />
    </Layout>
  );
}
